import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { ToastrService } from 'ngx-toastr';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { DataService, CustomerService, DashboardService } from '../../../api/services';
import { SearchSource } from '../../../api/models/search-source';
import { SearchItem } from '../../../api/models/search-item';
import { Dashboard } from '../../../api/models/dashboard';
import { TransformDetail, SiteType, TimeSeriesRequest, TimeSeriesDetailTransform, TimeSeriesVariable, TimeSeriesDetailRequest } from '../../../api/models';
import { DataAnalysisTimeSeries } from '../../../api/models/data-analysis-time-series';
import { DataAnalysisConfig, DataAnalysisItem, DataAnalysisTransform } from '../../models/data-analysis';
import { DownloadCsvService } from 'src/service/download-csv.service';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { AlarmEditorComponent } from 'src/app/components/alarm-editor/alarm-editor.component';
import { OpenStreetMapComponent } from 'src/app/components/open-street-map/open-street-map.component';
import { BsDropdownConfig } from 'ngx-bootstrap/dropdown';

import * as Highcharts from "highcharts/highstock";
//import * as HighchartsMore from "highcharts/highcharts-more";
//import * as HighchartsExporting from "highcharts/modules/offline-exporting";
import exporting from "highcharts/modules/exporting";
import offlineExporting from "highcharts/modules/offline-exporting";
exporting(Highcharts);
offlineExporting(Highcharts);

//import * as _moment from 'moment-timezone';
//import { Moment } from 'moment';
//import 'moment-timezone';


import { SharedSeries, TimeSeriesDetail } from 'src/app/models/dashboard';
import { once } from 'events';
import { Subscription } from 'rxjs';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { SmartImageDetail } from 'src/app/components/smart-image-list/smart-image-list.component';

@Component({
  selector: 'app-data-analysis',
  templateUrl: './data-analysis.component.html',
  styleUrls: ['./data-analysis.component.css'],
  providers: [{ provide: BsDropdownConfig, useValue: { isAnimated: true, autoClose: true } }]
})
export class DataAnalysisComponent implements OnInit {
  @ViewChild('alarmEditor', { read: AlarmEditorComponent, static: true }) alarmEditor: AlarmEditorComponent;
  @ViewChild('streetMap', { read: OpenStreetMapComponent, static: true }) map: OpenStreetMapComponent;
  @ViewChild('tabs', { static: false }) tabs?: TabsetComponent;
  @ViewChild("downloadData", { static: false }) downloadDataModal: ModalDirective;
  public analysis = new DataAnalysisConfig();
  public showChartOptions: boolean = false;
  public showLegend: boolean = false;

  //public timeZone: string;
  //public timeZoneOffset: number;// = new Date().getTimezoneOffset();
  //public timeZoneOffsets: string[];

  loading: boolean = false;
  searchStarted: boolean = false;
  title = "app";
  chart;
  updateFromInput = false;
  Highcharts = Highcharts;
  stockConstructor = "stockChart";
  chartCallback;
  chartOptions : Highcharts.Options;

  private debounceTimer: any;
  public errorMessage: string = "";
  public inputFilter: string;
  public inputType: string = "TimeSeries";
  public pageSize: number = 25;
  public pageIndex: number = 1;
  private lastPageIndex: number = 1;
  public totalItems: number = 100;
  public maxPages: number = 4;
  private colours: string[];
  private plugins: Plugin[];
  public allTimeSeries: SearchSource[];
  public siteTypes: SiteType[];
  public siteTypeAny: SiteType = {siteTypeCode:"Any"} as SiteType;
  public siteType: SiteType = this.siteTypeAny;
  //customers: Customer[];
  //customerId: number;
  public transformList: TransformDetail[];

  public lastSearchText: string;

  public rangeLimiter: any;

  selectedPoint: any;
  overlays: any[];
  imageMessage: any;
  imageOverlay: any;
  
  sortableOptions: any;

  constructor(
    private dashboardService: DashboardService,
    private dataService: DataService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private app: ApplicationConfigService,
    private customerService: CustomerService,
    public azureAuthService: AzureAuthService,
    private downloadCsvService: DownloadCsvService,
    private toasterService: ToastrService,
    private cdr: ChangeDetectorRef) {
      Highcharts.setOptions({
        time: {
            timezone:  this.app.tenantTimeZone,
            useUTC: false
        }
      });
      
      //this.timeZone = app.getCurrentTimeZone();
      //this.timeZoneOffset = - app.getTimeZoneOffset();
      //this.timeZoneOffsets = app.getZimeZones();
      console.log('TimeZone', this.app.tenantTimeZone);
      
      this.updateChart(false);

      app.customerChanged$.subscribe(cid => {
        this.changeCustomer();
      });
      this.lastSearchText = this.inputFilter;
  }

  updateChart(redraw){
    if (!redraw){
      this.chartOptions =  {
        chart: {
          backgroundColor: 'transparent',
          zooming: {
            type: 'x'
          }
        },
        navigator:{
          adaptToUpdatedData: false
        },
        rangeSelector:{
          enabled: false
        },
        title: {
          text: ''
        },
        credits: {
          enabled: false
        },
        exporting: {
          enabled: true,
          fallbackToExportServer: false,
          sourceWidth: 1000,
          sourceHeight: 600,
          buttons: {
            contextButton: {
                theme:{
                  fill:"transparent",
                  stroke:"none"
                },
                symbol: 'circle',
                symbolFill: 'transparent'
            }
          },
          chartOptions:{
            chart: {
              backgroundColor: 'white',
              styledMode: false
            },
            navigator: {
              enabled: false
            },
            scrollbar: {
              enabled: false
            },
            rangeSelector: {
              enabled: false
            },
            title: {
              style: { color: '#000000' }
            },
            legend: {
              itemStyle: { color: '#000000' }
            },
            xAxis: {
              labels: {
                style: {
                  color: '#000000',
                  fontSize: '12px'
                }
              },
              title: {
                style: { color: '#000000' }
              }
            },
            yAxis: [
              {
                labels: {
                  style: {
                    color: '#000000',
                    fontSize: '12px'
                  }
                },
                title: {
                  style: { color: '#000000' }
                }
              },
              {
                labels: {
                  style: {
                    color: '#000000',
                    fontSize: '12px'
                  }
                },
                title: {
                  style: { color: '#000000' }
                }
              }
            ]
          }
        },
        lang: {
          noData: "No Time Series Selected"
        },
        legend: {
          enabled: false
        },
        /*time: {
          //timezone: this.app.tenantTimeZone
          //timezone: "Australia/Hobart"
        },*/
        plotOptions: {
          line:{  
            softThreshold:false,
            point:{  
               events:{  
   
               }
            }
          },
          series: {
            showInNavigator: true,
            allowPointSelect: true,
            point:{
              events:{
                select: function(){
                  
                }
              }
            }
          }
        },
        tooltip: {
          shape: 'rect',
          headerShape: 'callout',
          borderWidth: 0,
          shadow: false,
          positioner: function (width, height, point) {
              var chart = this.chart,
                  position;
    
              if (point.isHeader) {
                  position = {
                      x: Math.max(
                          // Left side limit
                          chart.plotLeft,
                          Math.min(
                              point.plotX + chart.plotLeft - width / 2,
                              // Right side limit
                              //todo: below
                              //chart.chartWidth - width - chart.marginRight
                          )
                      ),
                      y: point.plotY
                  };
              } else {
                  position = {
                      x: point.series.chart.plotLeft,
                      y: point.series.yAxis.max - chart.plotTop
                  };
              }
    
              return position;
          }
      },
        xAxis: {
          type: 'datetime',
          ordinal: false,
          plotLines: [{
            id: 'now',
            color: 'grey',
            dashStyle: 'longdash',
            width: 1,
            value: new Date().getTime()
          }] as any[]
        },
        yAxis: [{
          title: {
            text: this.analysis.leftTitle ?? ""
          },
          opposite: false,
          startOnTick: false,
          endOnTick: false,
          lineWidth: 1,
          min: this.analysis.leftMin === this.analysis.leftMax ? null : this.analysis.leftMin,
          max: this.analysis.leftMin === this.analysis.leftMax ? null : this.analysis.leftMax
        }, {
          title: {
            text: this.analysis.rightTitle ?? ""
          },
          opposite: true,
          startOnTick: false,
          endOnTick: false,
          lineWidth: 1,
          min: this.analysis.rightMin === this.analysis.rightMax ? null : this.analysis.rightMin,
          max: this.analysis.rightMin === this.analysis.rightMax ? null : this.analysis.rightMax
        }]
      };
    }
    else {
      this.chart.yAxis[0].setExtremes(
          this.analysis.leftMin == null ? null : Number(this.analysis.leftMin),
          this.analysis.leftMax == null ? null : Number(this.analysis.leftMax));
      this.chart.yAxis[1].setExtremes(
          this.analysis.rightMin == null ? null : Number(this.analysis.rightMin),
          this.analysis.rightMax == null ? null : Number(this.analysis.rightMax));
      this.chart.yAxis[0].update({ title: { text: this.analysis.leftTitle ?? "" } }, false);
      this.chart.yAxis[1].update({ title: { text: this.analysis.rightTitle ?? "" } }, true);
    }
  }

  toggleLegend() {
    this.showLegend = !this.showLegend;
    this.chart?.update({ legend: { enabled: this.showLegend } }, true);
  }

  /*updateTimeZone(tz){
    this.timeZone = tz;
    this.app.setTenantTimeZone(tz);
    this.chart.update({
      time: {
        timezoneOffset: this.app.getTimeZoneOffset()
      }
    });
  }  */

  ngOnInit() {
    console.log('Analysis')
    var date = new Date();
    date.setDate(date.getDate() - 14);
    this.analysis.from = date.toString();
    this.analysis.to = (new Date()).toString();

    this.dataService.DataGetSiteTypes(this.app.customerId).subscribe(st => {
        this.siteTypes = st;
    });

    this.dataService.DataGetTransforms().subscribe(d => {
      this.transformList = d;
    });

    if (this.azureAuthService.isGlobalViewer()){
      if (this.app.customers == null){
        this.customerService.CustomerGetAllCustomers().subscribe(c =>{
          this.app.customers = c;
        });
      }
    } else {
      this.app.customerId = this.azureAuthService.userProfile.customerId;
    }

    if (this.app.customerId){
      this.doSearch(null);
    }
    //var currentTime = new Date();

    this.allTimeSeries = [];

    this.analysis.timeSeriesList = [];

    this.colours = [
      '#2f7ed8', '#8bbc21', '#910000', '#1aadce',
      '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a',
      "#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9",
      "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"
    ];

    const self = this;
    this.chartCallback = chart => {
      self.chart = chart;
      this.addTimeSeries();
    };

    // monitor lists for changes
    this.sortableOptions = {
      animation: 150,
      onUpdate: (event: any) => {
          
      }
    };

    setTimeout(() => {
      this.activeRoute.queryParams.subscribe(params => {
        if (params.uri){
          /*this.addTimeSeries({
            uri:params.uri,
            type: "TimeSeries",
          } as SearchItem);*/
          this.inputFilter = params.uri;
          this.doSearch(a => {
            if (this.allTimeSeries && this.allTimeSeries.length > 0){
              this.analysis.period = "today";
              this.addTimeSeries(this.allTimeSeries[0] as SearchItem);
              this.tabs.tabs[1].active = true;
            }
          });
        }
      });
    }, 500);
  }

  setSiteType(siteType){
    this.siteType = siteType;
    this.doSearch(null);
  }

  showImage(point){
    this.selectedPoint = point;
    if (point.metaData && point.metaData['analysis']) {
      this.imageOverlay = JSON.parse(point.metaData['analysis']);
      this.overlays = [];
      this.imageMessage = point.metaData['analysis'];
      const img = new Image();
      img.onload = (i:any) => {
        var img = document.getElementById('selectedImage'); 
        var imgWidth = i.target.width;
        var imgHeight = i.target.height;
        for (let obj of this.imageOverlay.objects){
          const startX = (obj.rectangle.x / imgWidth) * 100;
          const startY = (obj.rectangle.y / imgHeight) * 100;
          const width = (obj.rectangle.w / imgWidth) * 100;
          const height = (obj.rectangle.h / imgHeight) * 100;
          this.overlays.push([startX,startY,width,height,obj.object]);
        }
      }
      img.src = point.valueStr;
      //this.viewImageDetail.show();
    }
  }

  onSearchInput() {
    // 1. Clear the previous timeout on every keyup
    clearTimeout(this.debounceTimer);

    // 2. Set a new timeout to run after 400ms
    this.debounceTimer = setTimeout(() => {
      this.doSearch(null);
    }, 400); // 400ms delay
  }

  selectedJson:string;

  showJson(point){
    this.selectedPoint = point;
    this.selectedJson = JSON.stringify(JSON.parse(point.valueStr), null, 2);
  }

  public openAlarmEditor(ts){
    this.alarmEditor.openModal(ts.uri);
  }

  public changeCustomer(){
    this.dashboards = null; 
    this.dataService.DataGetSiteTypes(this.app.customerId).subscribe(st => {
      this.siteTypes = st;
      this.doSearch(null);
    });  
  }

  public selectSite(siteUri){
    this.inputFilter = siteUri;
    this.doSearch(null);
  }
  
  //dataSearchSubscription: Subscription;
  public doSearch(onComplete) {
    /*if (this.dataSearchSubscription && !this.dataSearchSubscription.closed){
      this.dataSearchSubscription.unsubscribe();
    }*/
    if (this.inputFilter == null){
      this.inputFilter = "";
      this.lastSearchText = "";
    }
    if (this.loading){
      // don't try another search if one is active
      return;
    }
    console.log(this.pageIndex);
    if(this.lastSearchText != this.inputFilter)
    {
      this.pageIndex = 1;      
      this.cdr.detectChanges();
    }
    this.lastSearchText = this.inputFilter;

    // if(this.allTimeSeries.length >=this.pageSize)
    // {
    //   this.totalItems = Math.max((this.pageIndex * this.pageSize - 1) + this.pageSize + 1,100);
    // }
    // else{
    //   this.totalItems = (this.pageIndex * this.pageSize - 1) + this.allTimeSeries.length;
    // }

    this.loading = true;
    this.searchStarted = true;
    this.allTimeSeries = [];
    this.map.clearSearchResults();
    var searchFilter = "";
    if (this.siteType.siteTypeCode != "Any"){
      searchFilter = ' mt:siteType="' + this.siteType.siteTypeCode + '"';
    }
    //this.dataSearchSubscription = 
    this.dataService.DataSearch({customerId: this.app.customerId, type: this.inputType, search: this.inputFilter + searchFilter, searchSize: this.pageSize, pageIndex: this.pageIndex, includeAlarms: true, filterOld: false}).subscribe(r => {
      //this.allTimeSeries = r;
      console.log("Do Search");
      
      this.loading = false;
      console.log('number of elements search:',this.allTimeSeries.length);
      this.errorMessage = "";
      
      var all = [];
      if (r){
        for (let source of r){
          for (let item of source.items){
            all.push({
              type: source.type,
              siteName: source.siteName,
              siteType: source.siteType,
              siteDescription: source.siteDescription,
              siteUri: source.siteUri,
              name: item.name,
              description: item.description,
              uri: item.uri,
              alarms: item.alarms,
              latestValue: item.latestValue,
              latestTime: item.latestTime,
              latitude: item.latitude,
              latitudeTxt: item.latitude == null ? null : Math.round(item.latitude*1000)/1000,
              longitude: item.longitude,
              longitudeTxt: item.longitude == null ? null : Math.round(item.longitude*1000)/1000,
              virtualTimeSeriesId: item.virtualTimeSeriesId,
              item: item
            });
            
          }
        }
      }
      
      this.map.showSearchResult(all, 
        // onload
        (marker, item) => {
          if (this.findTimeSeries(item.uri)){
            marker.setIcon(this.map.selectedIcon);
          }
        },
        // onselect
        (marker, item) => {
          var ts = this.findTimeSeries(item.uri)
          if (ts){
            marker.setIcon(this.map.defaultIcon);
            this.removeTimeSeries(ts);
          } else {
            marker.setIcon(this.map.selectedIcon);
            this.addTimeSeries(item);
          }
        }, true);
      this.allTimeSeries = all;
      console.log('all size:',all.length);
      

      if(all.length >= this.pageSize)
      {
        this.totalItems = Math.max(((this.pageIndex-1) * this.pageSize) + this.pageSize + 1,100);
        this.maxPages = 4;
        this.cdr.markForCheck();
      }
      else{
        this.totalItems = ((this.pageIndex-1) * this.pageSize) + this.allTimeSeries.length;
        if(this.pageIndex < 4)
          {
            this.maxPages = this.pageIndex;
          }
          this.cdr.markForCheck();
      }

      
      if (onComplete){
        onComplete();
      }
      this.cdr.detectChanges();
    }, error => {
      this.loading = false;
      console.log(error);
      this.errorMessage = " :  " + error.error;
    });
    
  }


  canAddTimeSeries(uri: string, type: string) {
    for (let ts of this.analysis.timeSeriesList) {
      if (ts.uri === uri && ts.source === type) {
        return false;
      }
    }
    return this.analysis.timeSeriesList.length < this.colours.length;
  }

  clearAllTimeSeries(){
    for (let ts of this.analysis.timeSeriesList){
      this.removeTimeSeries(ts);
    }
  }

  addTimeSeries(searchResult?: any) {
    if (!searchResult) {
      return;
    }

    if (this.tabs){
      this.tabs.tabs[1].disabled = false;
      this.tabs.tabs[2].disabled = false;
      this.tabs.tabs[3].disabled = false;
    }

    var ts = {
      name: searchResult.name,
      uri: searchResult.uri,
      source: searchResult.type,
      axis: 0,
      width: 1,
      type: "line",
      style: "solid",
      active: true,
      colour: this.colours[this.analysis.timeSeriesList.length],
      data: null,
      item: searchResult.item,
      result: searchResult,
      transform: null,
      transforms: [],
      series: null,
      showInNavigator: true,
      compare: 'percent',
      toggle: false
    };

    this.analysis.timeSeriesList.push(ts as DataAnalysisItem);

    console.log('Adding ' + searchResult.uri);
    
    this.getData(ts); 
  }

  public loadSeriesData(chart: any, ts: DataAnalysisItem) {
    var seriesData = [];

    if (ts.data && ts.data.values) {
      if (ts.data.from && ts.data.to) {
        this.analysis.from = ts.data.from;
        this.analysis.to = ts.data.to;
        this.chart.xAxis[0].setExtremes(new Date(this.analysis.from).getTime(), new Date(this.analysis.to).getTime(), true);
      }
      for (let v of ts.data.values) {
        seriesData.push([new Date(v.timeStamp).getTime(), v.value]);
      }
    }

    if (this.rangeLimiter == null){
      var data = [[new Date(this.analysis.from).getTime(),null], [new Date(this.analysis.to).getTime(),null]];
      this.rangeLimiter = this.chart.addSeries({
        name: "range limiter",
        data: data,
        color: 'white',
        lineWidth: 0,
        type: 'line'
      });
    } else {
      var data = [[new Date(this.analysis.from).getTime(),null], [new Date(this.analysis.to).getTime(),null]];
      this.rangeLimiter.setData(data);
    }

    chart.hideLoading();
    if (ts.series == null) {
      ts.series = this.chart.addSeries({
        name: ts.name == null ? ts.item.name : ts.name,
        data: seriesData,
        color: ts.colour,
        lineWidth: ts.width,
        type: ts.type,
        dashStyle: ts.style,
        yAxis: ts.axis
      });
    } else {
      if (ts.series.options.axis !== ts.axis) {
        ts.series.setData(seriesData);
      }
    }
    // update the now time
    //debugger;
    chart.xAxis[0].removePlotLine("now");
    chart.xAxis[0].addPlotLine({
      id: 'now',
      color: 'grey',
      dashStyle: 'longdash',
      width: 1,
      value: new Date().getTime()
    });
    //chart.xAxis[0].value = new Date().getTime();
    //chart.update();
    if (ts.data.from && ts.data.to) {
      this.analysis.from = ts.data.from;
      this.analysis.to = ts.data.to;
      this.chart.xAxis[0].update({min: new Date(this.analysis.from).getTime(), max:  new Date(this.analysis.to).getTime()}); 
      this.chart.navigator.xAxis.update({min: new Date(this.analysis.from).getTime(), max:  new Date(this.analysis.to).getTime()}, true); 
      this.chart.navigator.xAxis.setExtremes(new Date(this.analysis.from).getTime(), new Date(this.analysis.to).getTime(), true);
      this.chart.redraw();
      //this.chart.navigator.xAxis.set
    }
    if (ts.item.type == 'Media'){
      if (this.analysis.timeLapseList == null) {
        this.analysis.timeLapseList = {};
      } 
      const imageFeedImages = (ts.data.values ?? []).map(i => ({ src: i.valueStr, overlay: null, timeStamp: i.timeStamp } as SmartImageDetail));
      this.analysis.timeLapseList[ts.uri] = imageFeedImages;
    }
  }

  public updateSeries(ts: DataAnalysisItem) {
    var change = false;
    var type = ts.type;
    var stacked = false;
    var step = false;
    
    if (type.startsWith('stack')){
      type = type.substring(5);
      stacked = true;
    }
    if (type.startsWith('step')){
      type = type.substring(4);
      step = true;
    }

    if (ts && ts.series && ts.series.options) {
      if (ts.series.options.color !== ts.colour) {
        ts.series.options.color = ts.colour;
        change = true;
      }
      if (ts.series.options.lineWidth !== ts.width) {
        ts.series.options.lineWidth = ts.width;
        //if width = 0, show the line point/dot
        let markerState = ts.series.options.lineWidth > 0 ? false : true;
        ts.series.options.marker.enabled = markerState;
        change = true;
      }
      if (ts.series.options.type !== type) {
        ts.series.options.type = type;
        change = true;
      }
      if (ts.series.options.dashStyle !== ts.style) {
        ts.series.options.dashStyle = ts.style;
        change = true;
      }
      if (ts.series.options.axis !== ts.axis) {
        ts.series.options.yAxis = parseInt(ts.axis as any);
        change = true;
      }
      if (ts.series.options.step != step) {
        ts.series.options.step = step;
        change = true;
      }
      
      if (stacked){
        this.chartOptions.plotOptions.series = {
          stacking: 'normal'
        };
      }
            
      if (change) {
        ts.series.update(ts.series.options);
      }

      this.updateTimeSeries(ts);
    }
  }

  public timeChange(period) {
    this.updateAll();
  }

  public updateAll() {
    const chart = this.chart;
    for (let ts of this.analysis.timeSeriesList) {
      this.updateTimeSeries(ts);
    }
    this.getOrderedTimes(true);
  }

  updateTimeSeries(ts: DataAnalysisItem) {
    this.getData(ts);
  }

  applyToAll(ts: DataAnalysisItem) {
    if (confirm("This will replace all existing transforms?")){
      for (let tss of this.analysis.timeSeriesList) {
        if (tss != ts){
          tss.transforms = JSON.parse(JSON.stringify(ts.transforms));        
        }
      }
    }
  }

  public findTimeSeries(uri: string) {
    return this.analysis.timeSeriesList.find(ts => ts.uri === uri);
  }

  public removeTimeSeries(timeSeries: any): void {
    var index = this.analysis.timeSeriesList.indexOf(timeSeries);
    if (index > -1) {
      var ts = this.analysis.timeSeriesList[index];
      ts.series.remove();
      this.analysis.timeSeriesList.splice(index, 1);
      this.getOrderedTimes(true);
    }
    if (this.analysis.timeSeriesList.length == 0){
      this.tabs.tabs[1].disabled = true;
      this.tabs.tabs[2].disabled = true;
    }
    if (this.analysis.timeLapseList[timeSeries.uri]){
      delete this.analysis.timeLapseList[timeSeries.uri];
    }
  }

  public orderedTimes: any[];
  public orderedTimesLimited: any[];
  public getOrderedTimes(limit: boolean) {
    var times = [];
    try {
      if (this.analysis && this.analysis.timeSeriesList) {
        for (let ts of this.analysis.timeSeriesList) {
          if (ts.data && ts.data.values) {
            for (let tsv of ts.data.values) {
              /*if (times.length > 1000 && limit) {
                break;
              }*/
              if (times.indexOf(tsv.timeStamp) === -1) {
                times.push(tsv.timeStamp);
              }
            }
          }
        }
        times.sort();
        if (limit && times.length > 1000){
          this.orderedTimesLimited = times.slice(0, 1000);
        } else {
          this.orderedTimesLimited = times;
        }
        this.orderedTimes = times;
      }
    } catch (e) {
      //console.log("error getting ordered times");
    }
    return this.orderedTimes;
  }

  public getColumnsForTs(ts){
    if (ts.data.values == null || ts.data.values.length == 0) return null;

    var first = ts.data.values[0];
    if (first.value == null && first.valueStr != null && first.valueStr.startsWith('{')){
      try{
        var j = JSON.parse(first.valueStr);
        var columns = [];
        for (const [key, value] of Object.entries(j)) {
          columns.push(key)
        }
        return columns;
      }catch{
        return null;
      }
    }
    return null;
  }

  public getValueForTime(time, ts, column) {
    if (ts && ts.data && ts.data.values) {
      for (let tsv of ts.data.values) {
        if (tsv.timeStamp === time) {
          if (column != null && tsv.value == null && tsv.valueStr.startsWith('{')){
            try {
              var j = JSON.parse(tsv.valueStr);
              return j[column];
            } catch {

            }
          }
          return tsv.value == null ? tsv.valueStr : tsv.value;
        }
      }
    }
    return null;
  }

  public getPointForTime(time, ts) {
    if (ts && ts.data && ts.data.values) {
      for (let tsv of ts.data.values) {
        if (tsv.timeStamp === time) {
          return tsv;
        }
      }
    }
    return null;
  }

  public valueForTimeIsUrl(time, ts) {
    if (ts && ts.data && ts.data.values) {
      for (let tsv of ts.data.values) {
        if (tsv.timeStamp === time) {
          return tsv.valueStr && tsv.valueStr.contains('http');
        }
      }
    }
    return false;
  }

  public toggle(ts){
    ts.toggle = !ts.toggle;    
  }

  public addTransform(ts: DataAnalysisItem, transform: string){
    var transformDetail = this.transformList.find(t => t.id == transform);
    var config = [];
    if (transformDetail.parameters) {
      for (let ta of transformDetail.parameters){
        config.push({    
          name: ta.name,
          value: ta.defaultValue,
        });
      }
    }
    ts.transforms.push({
      transform: transformDetail,
      config: config
    });
  }

  public removeTransform(ts: DataAnalysisItem, transform: DataAnalysisTransform){
    var index = ts.transforms.indexOf(transform);
    if (index > -1){
      ts.transforms.splice(index, 1);
    }
  }

  public split(ts){
    var columns = this.getColumnsForTs(ts);
    var transform = this.transformList.find(t => t.id == 'json')
    if (columns != null){
      var newTs = [];
      for (var col of columns){
        var nts = {
          name: ts.name + ' ' + col,
          uri: ts.uri,
          axis: 0,
          width: 1,
          type: "line",
          style: "solid",
          active: true,
          colour: this.colours[this.analysis.timeSeriesList.length],
          data: null,
          item: ts.item,
          transform: null,
          transforms: JSON.parse(JSON.stringify(ts.transforms)),
          series: null,
          source: ts.source,
          result: ts.result
        } as DataAnalysisItem;
    
        if (col.startsWith('p')){
          nts.style = 'dash';
        }
        if (col.startsWith('variance')){
          nts.style = 'dot';
          nts.width = 0;
        }
        if (col.startsWith('average')){
          nts.width = 2;
        }
        // add an extra item to pull the JSON item out
        nts.transforms.push({
          transform: transform,
          config:[{name: 'path', value: '$.' + col}]
        });
        this.analysis.timeSeriesList.push(nts);
        newTs.push(nts)
      }

    }

    for (var ts of newTs){
      this.getData(ts);
    }
  }

  public downloadAllCSV(): void {
    let data = this.orderedTimes.map(time => {
      // Initialize the row with the time value.
      let row: { [key: string]: any } = {
        time: time
      };
    
      // A tracker for keys that have already been added to the row.
      let keyCount: { [key: string]: number } = {};
    
      let index = 0;
      
      this.analysis.timeSeriesList.forEach(ts => {
        let columns = this.getColumnsForTs(ts);
        if (columns != null) {
          for (const col of columns) {
            let baseKey = `${ts.name} - ${col}`;
            keyCount[baseKey] = (keyCount[baseKey] || 0) + 1;
            // If this is the first occurrence, use the base key, if not append the occurrence count.
            let key = keyCount[baseKey] > 1 ? `${baseKey} (${keyCount[baseKey]})` : baseKey;
      
            let value = this.getValueForTime(time, ts, col);
            row[key] = value != null ? value : '';
          }
        } else {
          let value = this.getValueForTime(time, ts, null);
          if (ts.name) {
            let baseKey = ts.name;
            keyCount[baseKey] = (keyCount[baseKey] || 0) + 1;
            let key = keyCount[baseKey] > 1 ? `${baseKey} (${keyCount[baseKey]})` : baseKey;
            row[key] = value != null ? value : '';
          } else {
            row[`${ts.uri}-${index}`] = value != null ? value : '';
            index++;
          }
        }
      });
      
      return row;
    });
    

    let subHeaderList: string[] = ['', '']; // First two must empty strings so so URI's sit beneath data name
    this.analysis.timeSeriesList.forEach(ts => {
      subHeaderList.push(ts.uri);
    });

    if (data.length > 0) {
      let date = new Date();
      let filename = `Data Analysis - ${date.getFullYear()}-${date.getMonth()}-${date.getDay()}T${date.getHours()}-${date.getMinutes()}-${date.getSeconds()}`
      this.downloadCsvService.downloadCSV(data, filename, Object.keys(data[0]), subHeaderList)
    }
  }

  public downloadSingleCSV(ts: any): void {
    if (ts.data && ts.data.Values) {
      let data = ts.data.Values;
      let date = new Date();

      let filename = `${ts.uri} - ${date.getFullYear()}-${date.getMonth()}-${date.getDay()}T${date.getHours()}-${date.getMinutes()}-${date.getSeconds()}`;

      this.downloadCsvService.downloadCSV(data, filename, ['TimeStamp', 'Value']);
    }
  }

  public duplicate(tsIn: any): void {
    if (!tsIn) {
      return;
    }
    
    var ts = {
      name: tsIn.name,
      uri: tsIn.uri,
      axis: 0,
      width: 1,
      type: "line",
      style: "solid",
      active: true,
      colour: this.colours[this.analysis.timeSeriesList.length],
      data: null,
      item: tsIn.item,
      transform: null,
      transforms: JSON.parse(JSON.stringify(tsIn.transforms)),
      result: tsIn.result,
      series: null
    } as any;

    this.analysis.timeSeriesList.push(ts);
    console.log('Adding ' + tsIn.uri,tsIn.name);
    
    this.getData(ts);
  }

  public getData(ts: DataAnalysisItem){
    const self = this;
    const chart = this.chart;
    chart.showLoading();
    var timeSeries = {} as TimeSeriesRequest;
    
    if (ts.item.virtualTimeSeriesId){
      timeSeries.virtualTimeSeriesId = ts.item.virtualTimeSeriesId;
    }else{
      timeSeries.single = {
        variable: {
          uri: ts.uri,
          transforms: this.getTransformConfig(ts),   
        }       
      };
    }
    //  debugger;
    this.dataService.DataGetData({ 
      customerId: this.app.customerId, 
      request:{
        period: this.analysis.period, 
        type: ts.item.type,
        timeZoneOffset: this.app.getTimeZoneOffset(null),
        forceEmbed: false,
        index: 0,
        publishedIdentifier: null,
        siteUri: (ts as any).result?.siteUri,
        timeSeries: timeSeries
      }
    }).subscribe(d => {
        ts.data = d;
        this.loadSeriesData(chart, ts);
        this.getOrderedTimes(true);
        this.loadMap(ts, d);
      }, error =>{
        chart.hideLoading();
        if(error.status == 406)
        {
          this.toasterService.warning("No data found over this time period.");
        }
        else
        {
          this.toasterService.error("Failed to load data.");
        }

        
      });
  }

  public getTransformConfig(item: DataAnalysisItem): TimeSeriesDetailTransform[] {
    var config = [];
    if (item && item.transforms){
      for (let transform of item.transforms){
        var configItem = {
          transform: { id: transform.transform.id },
          config: transform.config 
        };
        config.push(configItem);
      }
    }
    return config;
  }

  public newDashboardName: string;
  public selectedDashboardId: number;
  public dashboards: Dashboard[];

  public loadDashboards(){
    if (!this.dashboards) {
      this.dashboards = [];
      this.dashboardService.DashboardGetCustomerDashboards(this.app.customerId).subscribe(
        d => this.dashboards = d.filter(dd => dd.siteType == null || dd.siteType == ""  ), 
        err => this.toasterService.error("Cannot Load Dashboards")
      );
    }
  }

  public saveDataAnalysis(): void {
    //this.analysis.timeSeriesList = [];
    if (!this.analysis.timeSeriesList || this.analysis.timeSeriesList.length === 0) {
        this.toasterService.error("Data Analysis", "No time series selected");
        return
    }

    if (!this.selectedDashboardId) {
        if (this.newDashboardName) {
            this.saveToNewDashboard();
        } else {
            this.toasterService.error("Data Analysis", "Must specify new dashboards name");
        }
    } else {
        this.saveToExistingDashboard();
    }
} 

  public createNewWidget(): any {
    let widget: any = {
        from: "0001-01-01T00:00:00+00:00",
        to: "0001-01-01T00:00:00+00:00",
        current: "2020-02-20T12:40:41.4960495+11:00",
        realTime: false,
        showTitle: false,
        showLegend: false,
        leftMin: 0,
        leftMax: 0,
        rightMin: 0,
        rightMax: 0,
        timeSeriesList: [ ],
        timeSeriesDetailList: [ ],
        dataSourceDetailList: [],
        bandDetailList: [],
        lineDetailList: [],
        widgetId: 0,
        size: 6,
        height: 200,
        type: "Chart",
        period: this.analysis.period
    };

    this.analysis.timeSeriesList.forEach(ts => {
        let values = {
            uri: ts.uri,
            virtualTimeSeriesId: ts.item.virtualTimeSeriesId,
            siteUri: (ts as any).result.siteUri,
            axis: ts.axis,
            type: ts.type,
            style: ts.style,
            showMarker: false,
            size: 1,
            transforms: ts.transforms
        };

        widget.timeSeriesList.push(values);
        widget.timeSeriesDetailList.push(values);
    })

    return widget;
  }

  public saveToNewDashboard(): void {
    let dashboard: any = {
        name: this.newDashboardName,
        isNew: true,
        customerId: this.app.customerId,
        columns: [{ widgets: [] }, { widgets: [] }, { widgets: [] }]
    }

    dashboard.columns[1].widgets.push(this.createNewWidget());
    this.dashboardService.DashboardAddDashboard(dashboard).subscribe(d => {
      this.toasterService.success("Dashboard", "Created");
      this.router.navigate(['/dashboard/' + d.dashboardId]);
    }, err => {
      this.toasterService.error("Dashboard","Failed to Update");
    });
  }

  public saveToExistingDashboard(): void {
    this.dashboardService.DashboardGetDashboard(this.selectedDashboardId).subscribe(d => {
        let dashboard = d;
        dashboard.columns[1].widgets.push(this.createNewWidget());
        this.dashboardService.DashboardUpdateDashboard(dashboard).subscribe(d => {
          this.toasterService.success("Dashboard", "Updated");
          this.router.navigate(['/dashboard/' + d.dashboardId]);
        }, err => {
          this.toasterService.error("Dashboard","Failed to Update");
        });
    }, err => {
      this.toasterService.error("Failed to find existing dashboard");
    });
  }

  sortColumn: string;
  sortDirection: boolean;

  columnSortStyle(column: string){
      if (column == this.sortColumn && this.sortDirection){
          return "fa fa-sort-desc";
      }
      
      if (column == this.sortColumn && !this.sortDirection){
          return "fa fa-sort-asc";
      }
      return "fa fa-sort";
  }

  columnSort(column: string){
      this.sortColumn = column;
      this.sortDirection = !this.sortDirection;
      console.log("SORT:" + this.sortColumn + " " + this.sortDirection);
  }

  setPageSize(index){
    this.pageSize = index;
    this.doSearch(null);
  }

  pageChange(event){
    console.log(event);
    //this.pageSize = event.itemsPerPage;
    this.pageIndex = event.page;
    if(this.lastPageIndex != this.pageIndex)
    {
      this.doSearch(null);
    }
    this.lastPageIndex = this.pageIndex;
  }

  loadMap(ts: DataAnalysisItem, tsv: DataAnalysisTimeSeries) {
    if (tsv && tsv.values && tsv.values.length == 1) {
      for (let v of tsv.values) {
        this.map.loadGeoJson(ts.uri, v.valueStr, ts.colour);
      }
    } else {
      this.map.loadTracker(ts.uri, tsv.values, ts.colour, "tracker");
    }
  }

  mapTabSelected(event){
    this.map.redraw();
  }

  downloadOptions: any = {
      wizardStep: 1,
      mode: '',
      format: '',
      fromDate: null,
      toDate: null,
      sendDataTo: null,
      includeUnitType: false,
      includeUnits: false,
      includeSite: false
  }

  downloadDataWizardPrev(){
    if (this.downloadOptions.wizardStep <= 1) return;
    this.downloadOptions.wizardStep--; 
  }

  downloadDataWizardNext(){
    if (this.downloadOptions.wizardStep >= 3) return;
    this.downloadOptions.wizardStep++; 
  }

  selectDownloadMode(mode: string){
    this.downloadOptions.mode = mode;
    if (mode == 'Advanced'){
      this.downloadOptions.wizardStep++; 
    }
  }

  selectDownloadFormat(format: string){
    this.downloadOptions.format = format;
    this.downloadOptions.wizardStep++; 
  }

  startDownload(){
    this.downloadOptions.sendDataTo = this.azureAuthService.userProfile.emailAddress;
    //this.downloadOptions.fromDate = this.azureAuthService.userProfile.emailAddress;
    //this.downloadOptions.toDate = this.azureAuthService.userProfile.emailAddress;
    this.downloadDataModal.show();
  }

  cancelDownload(){
    this.downloadDataModal.hide();
    this.clearDownloadSettings();
  }

  downloadCsv(){
    if (this.downloadOptions.mode == 'Express'){
      this.downloadAllCSV();
      this.toasterService.success("Download", "CSV Download started");
      this.downloadDataModal.hide();
      this.clearDownloadSettings();
    } else {
      var timeSeriesList: TimeSeriesDetailRequest[] = [];
      for (let ts of this.analysis.timeSeriesList){
        var timeSeriesDetail= {
          type: ts.item.type,
          timeZoneOffset: this.app.getTimeZoneOffset(null),
          forceEmbed: false,
          index: 0,
          publishedIdentifier: null,
          siteUri: (ts as any).result.siteUri,
          timeSeries: timeSeries
        } as TimeSeriesDetailRequest;
        var timeSeries= {} as TimeSeriesRequest;

        if (ts.item.virtualTimeSeriesId){
          timeSeries.virtualTimeSeriesId = ts.item.virtualTimeSeriesId;
        } else {
          timeSeries.single = {
            variable: {
              uri: ts.uri,
              transforms: this.getTransformConfig(ts),   
            }       
          };
        }
        timeSeriesDetail.timeSeries = timeSeries;
        timeSeriesList.push(timeSeriesDetail);
      }

      this.dataService.DataDownloadData({
        customerId: this.app.customerId,
        timeSeries: timeSeriesList,
        from: this.downloadOptions.fromDate,
        to: this.downloadOptions.toDate,
        format: this.downloadOptions.format,
        sendToEmail: this.downloadOptions.sendDataTo,
        includeUnitTypes: this.downloadOptions.includeUnitType,
        includeUnits: this.downloadOptions.includeUnits,
        includeSite: this.downloadOptions.includeSite
      }).subscribe(d => {
        this.toasterService.success("Download", "CSV Download request queued");
        this.downloadDataModal.hide();
        this.clearDownloadSettings();
      }, e => {
        this.toasterService.error("Download", "CSV Download request failed: " + e.error);
      });
      
    }
  }

  clearDownloadSettings(){
    this.downloadOptions.wizardStep = 1;
    this.downloadOptions.mode = '';
    this.downloadOptions.format = '';
  }
}
